import { connect } from 'react-redux';
import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import ProjectExportDataQuery from '../graphql/ProjectExportData.graphql';
import ExportMutation from '../graphql/ExportMutation.graphql';
import {actions as system} from '../reducers/system';
import {actions as labelCollection} from '../reducers/labelCollection';
import Message from '../enums/Message';
import _ from 'lodash';

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			isLoading: state.system.isLoading
		}
	},
	dispatch => {
		return {
			addMessage: (message) => dispatch(system.addMessage(message)),
			startLoading: () => dispatch(system.startLoading()),
			endLoading: () => dispatch(system.endLoading()),
            fetchLabelCollections: () => dispatch(labelCollection.fetch())
		}
	}
)
@graphql(
	ProjectExportDataQuery, {
		skip: props => props.selectedProject === null,
		options: props => {
			return {
				variables: {
					project: props.selectedProject.name
				}
			}
		}
	}
)
@graphql(
	ExportMutation, {
		name: 'export'
	}
)
export default class ExportProject extends Component
{

	constructor(prop) {
		super(prop);

		this.state = {
			languages: [],
			error: false
		};
	}

	addLanguage = languageIdentifier => {
		if(_.includes(this.state.languages, languageIdentifier)){
			this.setState({languages: _.without(this.state.languages, languageIdentifier)});
		} else {
			this.setState({languages: _.concat(this.state.languages, [languageIdentifier])});
		}
	};

	export = () => {
		this.props.startLoading();

		this.props.export({
			variables: {
				project: this.props.selectedProject.name,
				languages: this.state.languages
			}
		})
			.then(
				result => {
					if(_.has(result.data, 'lockLabelCollectionLanguagesAndGetTranslationsExportFileUrl')) {
					    this.props.fetchLabelCollections()
						window.location.assign(_.get(result.data, 'lockLabelCollectionLanguagesAndGetTranslationsExportFileUrl').url);
					} else {
						this.props.addMessage(new Message(
							Message.TYPE_ERROR,
							500,
							'Export did not return a file'
						));
					}
				},
				error => {
					this.props.addMessage(new Message(
						Message.TYPE_ERROR,
						500,
						'Could not export Project: ' + error.message
					));
				}
			)
			.finally(this.props.endLoading).then(
				this.props.history.push('/show/' + encodeURIComponent(this.props.selectedProject.name))
		);
	};

	componentDidMount() {
		this.handleGraphqlRequest(null, this.props.data);
	}

	componentDidUpdate(prevProps) {
		this.handleGraphqlRequest(prevProps.data, this.props.data);
	}

	handleGraphqlRequest = (prevData, newData) => {
		if(newData) {
			if (_.get(prevData, 'loading', false) !== newData.loading) {
				if (newData.loading) {
					this.props.startLoading();
				} else {
					this.props.endLoading();
				}
			}

			if (_.get(prevData, 'error', _.noop()) !== newData.error) {
				this.props.addMessage(new Message(
					Message.TYPE_ERROR,
					500,
					'Could not fetch language data of project'
				));
				this.setState({error: true});
			}
		}
	};

	render() {
		const {selectedProject, data} = this.props;

		if(selectedProject === null || this.state.error || !data.project) {
			return null;
		}

		return (
			<div className="card">
				<div className="card-body">
					<div className="col-6 pull-left">
					{
						data.project.languagesInUse.map(({language, lockable}) => (

							<div className={'form-check xpull-left' + (lockable ? '' : ' disabled')} key={language.identifier}>
								<label className="form-check-label">
									<input
										type="checkbox"
										className="form-check-input"
										onChange={() => this.addLanguage(language.identifier)}
										disabled={!lockable}
									/>
									<span className="form-check-sign"/>
									{language.name}
									<br />{lockable ? '' : 'Language is locked by different user'}
								</label>
							</div>

						))
					}
					</div>
					<div className="col-6 pull-left">
						<h4>Rules for handling the export file</h4>
						<ul>
							<li>Do not add or remove columns</li>
							<li>Do not add lines</li>
							<li>Deleting lines means that when the file is re-imported, these values​are not changed in the system. However, they are not deleted from the system either.</li>
							<li>Leave the first line completely unchanged</li>
							<li>Only edit the values ​​in the back columns with the language abbreviations, leave all other columns unchanged</li>
							<li>Ignore all texts with the content "### NOT_USED ###" and leave them in the file, no text is required for these languages ​​or plural forms</li>
							<li>All values ​​in curly brackets are variables that are replaced when the text is output. Do not change these placeholders.</li>
							<li>Don't use macros in any cells, just pure values</li>
						</ul>
					</div>
					<div>
						All collections in the selected languages ​​will be blocked for other users and they will be exported. The lock is lifted again when importing. If you change label translations online between import and export, they may be overwritten by the import.
					</div>

					<button onClick={this.export} className="btn btn-primary" disabled={this.state.languages.length === 0}>Lock & export</button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/screens/ExportProject.js